import React from 'react';

import ConfirmDialog from './confirm-dialog';

export default function ConfirmPage() {
  return <ConfirmDialog open />;
}
